import * as React from 'react';
import {useState} from 'react';
import '../helpers/TeamMembers.css'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import TeamDetailGo from './TeamDetailGo';

function TeamItem({name,profession,picture,href,content,phone,email}) {

  const [detail, setDetail] = useState(false);

  const handleClick = (e) => {}

  const onMouseEnter = () => {
    if (window.innerWidth < 600) {
        setDetail(false);
    }else {
        setDetail(true);
    }
};
const onMouseLeave = () => {
    if (window.innerWidth < 600) {
        setDetail(false);
    }else {
        setDetail(false);
    }
};

  return (
    <Card className='cardGeneral' sx={{maxWidth: 345}}>
      <a href={href}>
      <CardMedia
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className='teamToData'
        sx={{height: 350}}
        image={picture}
        loading='lazy'
      >{detail && <TeamDetailGo/>}</CardMedia></a>
      <CardContent className='cardContentInfo'>
        <Typography variant='h6' component='h6'><span><i>{name}</i></span></Typography>
        <Typography className='teamProfession' variant='h5' component='h5' style={{marginTop:10}}>{profession}</Typography>
        <Typography  gutterBottom variant='body1' component='p' style={{marginTop:10}}>{content}</Typography>
      </CardContent>
      <CardActions className='teamButton'>
        <a size='small' onClick={handleClick} href={phone}>Telefon</a>
        <span>|</span>
        <a size='small' onClick={handleClick} href={email}>Email</a>
      </CardActions>
      
    </Card>
  );
}

export default TeamItem;